import { render } from "./AddMarketingCampaignsModal.vue?vue&type=template&id=652a0c7b&ts=true"
import script from "./AddMarketingCampaignsModal.vue?vue&type=script&lang=ts"
export * from "./AddMarketingCampaignsModal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-distribution-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__